import React, { useEffect, useMemo, useState } from 'react';
import Tabs from '@/components/ui/tabs/Tabs';
import EdahabPayTab from './EdahabPayTab';
import WaafiPayTab from './WaafiPayTab';
import PremierWalletsTab from './PremierWalletsTab';
import RaamsPayTab from './RaamsPayTab';
import { useDispatch } from 'react-redux';
import { getSettingService } from '@/services/SettingServices';

const GATEWAY_VISIBILITY_KEYS = {
    waafi: 'frontend_show_waafi',
    edahab: 'frontend_show_edahab',
    premier_wallets: 'frontend_show_premier_wallets',
};

const isVisibleSetting = (value) => {
    if (value === undefined || value === null || value === '') return true;
    return String(value) !== '0';
};

const PaymentGatewayTabs = () => {
    const dispatch = useDispatch();
    const [gatewayVisibility, setGatewayVisibility] = useState({
        waafi: false,
        edahab: false,
        premier_wallets: false,
    });

    useEffect(() => {
        dispatch(
            getSettingService({
                key_list: Object.values(GATEWAY_VISIBILITY_KEYS),
            }),
        )
            .then((res) => {
                const settings = res?.data?.data || {};
                setGatewayVisibility({
                    waafi: isVisibleSetting(settings[GATEWAY_VISIBILITY_KEYS.waafi]),
                    edahab: isVisibleSetting(settings[GATEWAY_VISIBILITY_KEYS.edahab]),
                    premier_wallets: isVisibleSetting(settings[GATEWAY_VISIBILITY_KEYS.premier_wallets]),
                });
            })
            .catch(() => {
                setGatewayVisibility({
                    waafi: true,
                    edahab: true,
                    premier_wallets: true,
                });
            });
    }, [dispatch]);

    const tabsData = useMemo(() => {
        const tabs = [
            {
                tabsId: 'raams',
                title: 'Raams',
                content: <RaamsPayTab />,
            },
        ];

        if (gatewayVisibility.waafi) {
            tabs.push({
                tabsId: 'waafi',
                title: 'Waafi Pay',
                content: <WaafiPayTab />,
            });
        }

        if (gatewayVisibility.edahab) {
            tabs.push({
                tabsId: 'edahab',
                title: 'Edahab Pay',
                content: <EdahabPayTab />,
            });
        }

        if (gatewayVisibility.premier_wallets) {
            tabs.push({
                tabsId: 'premier_wallets',
                title: 'Premier Wallets',
                content: <PremierWalletsTab />,
            });
        }

        return tabs;
    }, [gatewayVisibility]);

    return (
        <div id="payment" className="db-tab-div active">
            <Tabs tabsData={tabsData} />
        </div>
    );
};

export default PaymentGatewayTabs;
